import { ImmutableObject, IVector3 } from '@inter-ikea-betrakta/viewer';
import { Component } from '@inter-ikea-core/core';
import { ProductDesign } from '@inter-ikea-storageone/range';
import { equals } from 'ramda';

export enum AutoFillDoorTypeEnum {
  HINGED = 'HINGED',
  NONE = 'NONE',
  SLIDING = 'SLIDING'
}

/**
 * Represents a single wall component with autofill properties.
 */
export default class AutofillSingleWallComponent implements Component {
  static id = 2089;
  typeId = AutofillSingleWallComponent.id;
  doStoreInSnapshot: boolean = false;
  serializable: boolean = false;
  wallWidth: number = 0;
  doorType: AutoFillDoorTypeEnum = AutoFillDoorTypeEnum.HINGED;
  cameraDirection: ImmutableObject<IVector3> | undefined;
  design: ProductDesign = ProductDesign.WHITE;
  frameHeight: number = 0;
  frameDepth: number = 0;
  finished: () => void;

  /**
   * Creates an instance of AutofillSingleWallComponent.
   * @param wallWidth - The width of the wall.
   * @param doorType - The type of door.
   * @param cameraDirection - The direction of the camera.
   * @param design - The design of the product.
   * @param frameHeight - The height of the frame.
   * @param frameDepth - The depth of the frame.
   * @param finished - Callback function to be called when finished.
   */
  constructor(
    wallWidth: number,
    doorType: AutoFillDoorTypeEnum,
    cameraDirection: ImmutableObject<IVector3> | undefined,
    design: ProductDesign,
    frameHeight: number,
    frameDepth: number,
    finished: () => void
  ) {
    this.wallWidth = wallWidth;
    this.doorType = doorType;
    this.cameraDirection = cameraDirection;
    this.design = design;
    this.frameHeight = frameHeight;
    this.frameDepth = frameDepth;
    this.finished = finished;
  }

  /**
   * Checks if this component is equal to another AutofillSingleWallComponent.
   * @param other - The other component to compare with.
   * @returns True if the components are equal, false otherwise.
   */
  eq(other: AutofillSingleWallComponent) {
    return (
      this.wallWidth === other.wallWidth &&
      this.doorType === other.doorType &&
      equals(this.cameraDirection, other.cameraDirection) &&
      this.design === other.design &&
      this.frameHeight === other.frameHeight &&
      this.frameDepth === other.frameDepth
    );
  }
}
